import { provisionTypes } from 'lib/constants';
import { HasCompletionType } from 'lib/types';

function isProvisionType(provision: string): provision is HasCompletionType {
  return provisionTypes.some((item) => item === provision);
}

export { isProvisionType };
